import { IconName } from '@infotech-soe/erp-ui-kit';
import { THotKey } from '@infotech-soe/metaschema';

import {
  BuiltinCaptionType,
  Caption,
  CaptionType,
} from '../../../models/caption/Caption';

import CategoryCommand, { RefreshStrategy } from './CategoryCommand';

class ReportsCommand extends CategoryCommand<Record<string, any>> {
  public async getCaption(): Promise<Caption> {
    return {
      type: CaptionType.BUILT_IN,
      caption: BuiltinCaptionType.REPORTS,
    };
  }

  public getIcon(): IconName {
    return 'print';
  }

  public getHotKey(): THotKey {
    return 'Ctrl+P'; // CommandHotKey.Print;
  }

  public getRefreshStrategy(): RefreshStrategy {
    return RefreshStrategy.NONE;
  }
}

export default ReportsCommand;
